import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import clone from 'clone';
import {
  Container,
  Dimmer,
  Grid,
  Loader,
  Header,
  Label,
  Button,
  Message,
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import config from '../../../config';
import BookingPayment from '../BookingPayment';
import { fetchM } from '../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import { bookingFlow } from '../../utils/routes';
import BookingSteppers from '../../components/BookingSteppers';
import { promptChangesLeave, promptChangesMessage } from '../../actions/prompt';

const isPRS = config.get('prs');

class Payment extends Component {
  static contextTypes = {
    store: PropTypes.object,
    router: PropTypes.object,
  }
  static propTypes = {
    route: PropTypes.shape({}),
    token: PropTypes.string,
    fetchNewBooking: PropTypes.func,
  }
  static defaultData = {
    id: '',
    bookingFeePayments: [],
    paymentStatusID: '',
  };
  static mapStateToProps = () => ({})
  static getPropsToState = (props) => {
    const loading = props.loading;
    const data = Object.assign({}, Payment.defaultData, props.data);
    return {
      loading,
      data,
      oriData: clone(data),
    };
  }
  constructor(props) {
    super(props);
    const state = Payment.getPropsToState(props);
    this.state = {
      ...state,
      systemData: [],
      isPaymentRequired: false,
    };
    this.validation = {};
  }
  componentDidMount() {
    if (!isPRS) {
      this.fetchSystemSettings();
    }
  }
  componentWillReceiveProps(nextProps) {
    const state = Payment.getPropsToState(nextProps);
    // don't allow state to override data if oriData is same
    if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
      state.data = this.state.data;
    }
    if (JSON.stringify(this.state.data) !== JSON.stringify(state.data) && !isPRS) {
      const data = state.data;
      if (data) {
        this.checkIsPaymentRequired(this.state.systemData, data);
      }
    }
    this.setState({ ...state });
  }
  setLoading = (loading = false) => (
    new Promise((res) => {
      this.setState({ loading }, res);
    })
  )
  checkBeforeLeave() {
    const isUnpaid = this.state.data && this.state.data.paymentStatusID && this.state.data.paymentStatusID === 'unpaid';

    this.context.router.setRouteLeaveHook(this.props.route, (nextLocation) => {
      if (this.state.isPaymentRequired && isUnpaid) {
        const { store } = this.context;
        const callback = () => {
          this.setState({ isPaymentRequired: false }, () => {
            if (this.state.data && this.state.data.project && this.state.data.project.loanTrackerDirectShow && nextLocation.pathname.includes(this.state.data.id) && !nextLocation.pathname.includes('loan')) {
              const redirectLocation = nextLocation;
              redirectLocation.pathname = `${nextLocation.pathname}loan/`;
              store.dispatch(promptChangesLeave(redirectLocation));
            } else {
              store.dispatch(promptChangesLeave(nextLocation));
            }
          });
        };
        const header = 'Add Payment';
        const message = 'Payment step is compulsory, your booking will be auto released. Do you still want to leave?';
        store.dispatch(promptChangesMessage({ header, callback, message }));
        return false;
      }
      return true;
    });
  }
  checkIsPaymentRequired = (systemData, data) => {
    let isPRequired = false;
    if (systemData && data) {
      const project = data.project;

      const systemARenabled = systemData && systemData.arBookingExpIsEnabled;
      const systemTimerSet = systemData && systemData.arBookingExpMoreThanMinutes !== '' && systemData.arBookingExpMoreThanMinutes !== '0';
      const systemPaymentRequired = systemData.arBookingExpUnpaidIsEnabled;

      const projectARenabled = project && project.arBookingExpIsEnabled;
      const projectPaymentRequired = project && project.arBookingExpMoreThanMinutes !== '' && project.arBookingExpMoreThanMinutes !== '0' && project.arBookingExpUnpaidIsEnabled;

      if (systemARenabled) {
        if (systemTimerSet && systemPaymentRequired) {
          isPRequired = true;
        } else if (!systemTimerSet && projectARenabled && projectPaymentRequired) {
          isPRequired = true;
        } else {
          isPRequired = false;
        }
      } else {
        isPRequired = false;
      }

      this.setState({ isPaymentRequired: isPRequired }, () => this.checkBeforeLeave());
    }
  }
  async fetchSystemSettings() {
    await this.setState({ loading: true });
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM('/settings/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setState({ loading: false });
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const systemData = await res.json();
      await this.setState({
        systemData,
      }, () => this.checkIsPaymentRequired(systemData, this.state.data));
    }
    await this.setState({ loading: false });
  }
  handleUpdatePayment = (payment) => {
    this.updateBooking(payment);
  }
  async updateBooking(booking, xid = this.state.data.id) {
    await this.setLoading(true);
    const { store } = this.context;
    try {
      await store.dispatch(fetchM(`/bookings/${xid}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(booking),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    this.props.fetchNewBooking();
    await this.setLoading(false);
    store.dispatch(flashSuccessMessage({ header: 'Update Success', message: 'Booking payment successfully updated.' }));
  }
  handleOnSave = (e) => {
    e.preventDefault();
    const { store } = this.context;
    const { data } = this.state;
    store.dispatch(push(bookingFlow(data, 2)));
  }
  render() {
    const { data } = this.state;
    const projectUnit = data.projectUnit;
    const project = data.project;
    return (
      <Container>
        <Grid>
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader inline="centered">Loading</Loader>
          </Dimmer>
          <Grid.Row>
            <Grid.Column width={16} textAlign="center">
              <Header as="h4" textAlign="center" style={{ marginTop: '1em' }}>
                Booking for <br className="large-hide small-hide tablet-hide" /><Link to={`/projects/${project && project.id}/units/${projectUnit && projectUnit.id}/`}>{projectUnit && projectUnit.reference}</Link>, {project && project.name} {projectUnit && projectUnit.isBumi && <Label size="mini">Bumi</Label>}
              </Header>
              {
                project && (project.paymentFlow || project.loanTrackerDirectShow) ?
                  <BookingSteppers
                    step={2}
                    totalSteps={project.paymentFlow && project.loanTrackerDirectShow ? 3 : 2}
                    lastStepLabel={project.paymentFlow && !project.loanTrackerDirectShow ? 'Payment' : 'Mortgage'}
                  />
                : ''
              }
              { (data.paymentStatusID !== 'paid' && isPRS) &&
                <Message warning>
                  Please fill in all payment details including cheque/bank draft proof of attachment. If information is incomplete, your reservation will be auto-released in 10 minutes.
                </Message>
              }
              <BookingPayment
                token={this.props.token}
                fetchNewBooking={this.props.fetchNewBooking}
                updateBookingPayment={this.handleUpdatePayment}
                data={data || {}}
                defaultBookingFeeAmount={project && project.defaultBookingFeeAmount}
              />
              <Button
                positive
                size="large"
                onClick={this.handleOnSave}
                style={{ marginBottom: '0.5em', marginTop: '1em' }}
                disabled={(isPRS && data.paymentStatusID !== 'paid') || false}
              >
                Save and Continue
              </Button>
              {
                !isPRS && this.state.isPaymentRequired && data.paymentStatusID === 'paid' ? '' : (
                  <p><Link to={bookingFlow(data, 2)}>Skip this step</Link></p>
                )
              }
              {/* {!isPRS && <p><Link to={bookingFlow(data, 2)}>Skip this step</Link></p>} */}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default connect(Payment.mapStateToProps)(Payment);




// WEBPACK FOOTER //
// ./src/containers/Bookings/Payment.jsx